import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-static-data',
  templateUrl: './static-data.component.html',
  styleUrls: ['./static-data.component.scss']
})
export class StaticDataComponent {
  
  @Input() public poolName: string;
  @Input() public note:boolean;
  @Input() public forTooltip:boolean;
  @Input() public forFormula:boolean;
  @Input() public poolInPerOpDays: boolean;
  @Input() public relativeShareInPool:boolean;
  @Input() public grossDistribution:boolean;
  @Input() public poolOut:boolean;
  @Input() public overheadfee:boolean;
  @Input() public commissionFee:boolean;
  @Input() public bunkerProcurementFee:boolean;
  @Input() public managementfee:boolean;
  @Input() public netPoolOut:boolean;  
  @Input() public netPoolOutPerOpDays:boolean;
  @Input() public profitSharing:boolean;
  @Input() public finalPayout:boolean;
  @Input() public poolPoints:boolean;
  @Input() public totalScrubberSavings:boolean;
  @Input() public totalIfoConsumption:boolean;
  @Input() public totalIfoConsumptionSidePanel:boolean;
  @Input() public totalIfoCost:boolean;
  @Input() public scrubberSavings:boolean;
  @Input() public bunkerConsMultiLSF:number;
  @Input() public bunkerConsMultiMGO:number;
  @Input() public lngSavings:boolean;
   
  
}
